import { useInView } from "@/hooks/useInView";
import { PictureAsset } from "@/components/site/PictureAsset";

const PHILOSOPHY_BASE = "/assets/homepage/philosophy/hero-image-1";

export default function Philosophy() {
  const [eyebrowRef, eyebrowIn] = useInView();
  const [titleRef, titleIn] = useInView();
  const [bodyRef, bodyIn] = useInView();
  const [mediaRef, mediaIn] = useInView();

  return (
    <section
      id="philosophy"
      className="philosophy"
      aria-labelledby="philosophy-title"
      data-testid="philosophy-section"
    >
      <div className="philosophy__inner">
        <div className="philosophy__text">
          <p
            ref={eyebrowRef}
            className={["philosophy__eyebrow", "reveal", eyebrowIn ? "is-visible" : ""].join(" ")}
            data-testid="philosophy-eyebrow"
          >
            Our Philosophy
          </p>

          <h2
            ref={titleRef}
            id="philosophy-title"
            className={[
              "philosophy__title",
              "reveal",
              "reveal-delay-1",
              titleIn ? "is-visible" : "",
            ].join(" ")}
            data-testid="philosophy-title"
          >
            <span>Not rooms.</span>
            <span className="philosophy__title-line-2">
              <em>Settings.</em>
            </span>
          </h2>

          <div className="philosophy__rule" aria-hidden="true" />

          <div
            ref={bodyRef}
            className={["reveal", "reveal-delay-2", bodyIn ? "is-visible" : ""].join(" ")}
          >
            <p className="philosophy__body philosophy__body--lede" data-testid="philosophy-body-0">
              Traditional-modern residential interiors rooted in Indian art,
              materiality, and everyday ritual.
            </p>
            <p className="philosophy__body" data-testid="philosophy-body-1">
              A home is not a collection of rooms. It is a sequence of moments —
              arrival, gathering, retreat, ritual, and pause.
            </p>
            <p className="philosophy__body" data-testid="philosophy-body-2">
              We compose each space through light, material, proportion, storage,
              and detail so that it feels personal, functional, and quietly
              theatrical.
            </p>
          </div>
        </div>

        <figure
          ref={mediaRef}
          className={["philosophy__media", "reveal", "reveal--media", mediaIn ? "is-visible" : ""].join(" ")}
          data-testid="philosophy-media"
        >
          <PictureAsset
            base={PHILOSOPHY_BASE}
            alt="Lived-in Indian-inspired home interior with arches, textiles, art, and natural light"
            sizes="(min-width: 880px) 50vw, 100vw"
            decoding="async"
          />
          <span className="philosophy__media-frame" aria-hidden="true" />
          <figcaption className="philosophy__caption" data-testid="philosophy-caption">
            Spaces shaped for the way life unfolds.
          </figcaption>
        </figure>
      </div>
    </section>
  );
}
